import React from 'react';
import PropTypes from 'prop-types';
import { Box } from '@mui/material';

const PageContainer = ({ children, sx = {} }) => (
  <Box
    className="admin-page-content"
    data-admin-page-container="true"
    sx={{
      width: '100%',
      display: 'flex',
      flexDirection: 'column',
      gap: { xs: 1.3, sm: 1.6, md: 2 },
      ...sx,
    }}
  >
    {children}
  </Box>
);

PageContainer.propTypes = {
  children: PropTypes.node.isRequired,
  sx: PropTypes.object,
};

export default PageContainer;
